/******************************************************************************
 * FILE:
 * src/modules/expense_management/workflow/components/WorkflowTable.js
 *
 * MODULE:
 * Expense Management
 *
 * FEATURE:
 * Workflow Master
 *
 * PURPOSE:
 * Display Workflow List
 *
 * RESPONSIBILITY:
 * - Presentational Component
 * - No Business Logic
 * - No API Calls
 ******************************************************************************/

import React from "react";

export default function WorkflowTable({

    loading,

    workflows = [],

    onOpen,

    onEdit,

    onDelete,

    onActivate,

    onDeactivate,

}) {

    return (

        <div className="card shadow-sm">

            <div className="card-body p-0">

                <div className="table-responsive">

                    <table className="table table-hover table-bordered mb-0">

                        <thead className="table-light">

                            <tr>

                                <th width="120">

                                    Code

                                </th>

                                <th>

                                    Workflow Name

                                </th>

                                <th width="180">

                                    Workflow Type

                                </th>

                                <th width="100">

                                    Version

                                </th>

                                <th width="100">

                                    Default

                                </th>

                                <th width="100">

                                    Status

                                </th>

                                <th width="280">

                                    Actions

                                </th>

                            </tr>

                        </thead>

                        <tbody>

                            {loading && (

                                <tr>

                                    <td
                                        colSpan="7"
                                        className="text-center p-4"
                                    >

                                        Loading...

                                    </td>

                                </tr>

                            )}

                            {!loading &&
                                workflows.length === 0 && (

                                <tr>

                                    <td
                                        colSpan="7"
                                        className="text-center p-4"
                                    >

                                        No workflow found.

                                    </td>

                                </tr>

                            )}

                            {!loading &&
                                workflows.map((workflow) => (

                                <tr
                                    key={workflow.workflow_id}
                                >

                                    <td>

                                        {workflow.code}

                                    </td>

                                    <td>

                                        <button

                                            type="button"

                                            className="btn btn-link p-0"

                                            onClick={() =>
                                                onOpen(workflow)
                                            }

                                        >

                                            {workflow.name}

                                        </button>

                                    </td>

                                    <td>

                                        {workflow.workflow_type}

                                    </td>

                                    <td>

                                        {workflow.version_no}

                                    </td>

                                    <td>

                                        {workflow.is_default
                                            ? "Yes"
                                            : "No"}

                                    </td>

                                    <td>

                                        {workflow.is_active
                                            ? (

                                                <span className="badge bg-success">

                                                    Active

                                                </span>

                                            ) : (

                                                <span className="badge bg-danger">

                                                    Inactive

                                                </span>

                                            )}

                                    </td>

                                    <td>

                                        <button

                                            className="btn btn-sm btn-primary me-1"

                                            onClick={() =>
                                                onOpen(workflow)
                                            }

                                        >

                                            Open

                                        </button>

                                        <button

                                            className="btn btn-sm btn-warning me-1"

                                            onClick={() =>
                                                onEdit(workflow)
                                            }

                                        >

                                            Edit

                                        </button>

                                        {workflow.is_active ? (

                                            <button

                                                className="btn btn-sm btn-secondary me-1"

                                                onClick={() =>
                                                    onDeactivate(workflow)
                                                }

                                            >

                                                Deactivate

                                            </button>

                                        ) : (

                                            <button

                                                className="btn btn-sm btn-success me-1"

                                                onClick={() =>
                                                    onActivate(workflow)
                                                }

                                            >

                                                Activate

                                            </button>

                                        )}

                                        <button

                                            className="btn btn-sm btn-danger"

                                            onClick={() =>
                                                onDelete(workflow)
                                            }

                                        >

                                            Delete

                                        </button>

                                    </td>

                                </tr>

                            ))}

                        </tbody>

                    </table>

                </div>

            </div>

        </div>

    );

}